import { Outlet } from 'react-router-dom'
import useAuth from '../../../hooks/useAuth'
import { useSelector } from 'react-redux'
import { RootState } from '../../../redux'
import TwoFactorAuth from '../../../components/portal/tfa/TwoFactorAuth'

const GoogleTwoFactor = () => {
    const { auth } = useAuth()
    const tfa = useSelector((state:RootState)=>state.tfa)

    const enabled_tfa = auth.data?.tfa_enabled ?? false;

    if(enabled_tfa && tfa === false) {
        return (
            <TwoFactorAuth />
        )
    } 

    return (
        <Outlet />
    )
}

export default GoogleTwoFactor